<!-- EPG间隔提示  -->
<template>
    <div class="EpgIntervalHint">
      <div class="EpgIntervalHintWrap" v-if="IsShowInterval" @mouseenter="Mouseenter" @mouseleave="mouseleave">
        <div class="exclamationPoinT">
          <i class="iconfont icon-warning"></i>
        </div>
        <div class="IntervalHintWrap" v-show="IntervalListSwitch">
          <div class="IntervalHint" v-loading="loadingHint">
            <div class="HintTitle">{{$t('lang.warning')}}</div>
            <div class="HintContenTop">
              {{$t('lang.EPGTimeGapWarning')}}
            </div>
            <div class="UpdateTime">
             {{$t('lang.updateTime')}}: {{UpdateTime}}
            </div>
            <div class="HintContenList">
               <div class="HintContenItem" v-for="(item, index) in IntervalHintList" :key="index">{{item.startTime + ' - ' + item.endTime}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Bus from '@/assets/js/vueBus.js'
import Outil from '@/assets/js/utils.js'
export default {
  props: {
    ShowIntervalHint: {
      default: 0,
      type: Number
    }
  },
  data () {
    return {
      // 是否显示空隙
      IsShowInterval: false,
      // 空隙列表
      IntervalHintList: [],
      // 空隙显示开关
      IntervalListSwitch: false,
      // 计时器
      getHintListTiming: null,
      // 获取最新信息的时间
      UpdateTime: '',
      // 加载load
      loadingHint: false
    }
  },
  created () {
    this.getHintList()
    this.clearTask()
    // this.getHintListTiming = setInterval(() => {
    //   this.getHintList()
    // }, 60 * 1000)
  },
  watch: {
    ShowIntervalHint () {
      this.Mouseenter()
    },
    // websocket通知监听
    '$store.state.BehaviorChange' (data) {
      console.log('EPG-Hint')
      if (typeof data != 'object') {
        return
      }
      if (data.action == 'EPGGapCheckModule') {
        this.IntervalHintList = this.TimeListTransition(data.gapBlocks)
        this.ShowUpdateTime()
      }
    }
  },
  mounted () {
  },
  methods: {
    // 鼠标进入调用
    Mouseenter () {
      this.IntervalListSwitch = true
      this.getHintList(1)
    },
    // 鼠标离开
    mouseleave () {
      this.IntervalListSwitch = false
    },
    // 显示更新的时间
    ShowUpdateTime () {
      this.UpdateTime = `${Outil.TransitionCurrentTime(new Date())} ${Intl.DateTimeFormat().resolvedOptions().timeZone}`
    },
    // 获取间隙时间
    getHintList (type) {
      if (type) {
        this.loadingHint = true
      }
      const programId = this.$BehaviorSyns.getProgramId()
      this.axios({
        method: 'post',
        url: Outil.getUrl('/EPG/checkEPGGap'),
        data: {
          programId
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        this.loadingHint = false
        if (res.data.errorCode == '0x0') {
          this.IsShowInterval = true
          this.IntervalHintList = this.TimeListTransition(res.data.result)
          this.ShowUpdateTime()
        } else if (res.data.errorCode == '81003102') {
          this.clearTask()
          this.IntervalHintList = []
        }
      })
        .catch((err) => {
          this.loadingHint = false
          console.log(err)
        })
    },
    // 时间戳转换显示时间
    TimeListTransition (List) {
      if (Array.isArray(List)) {
        List.forEach((item) => {
          item.startTime = Outil.TransitionCurrentTime(new Date(item.startTimeStamp))
          item.endTime = Outil.TransitionCurrentTime(new Date(item.endTimeStamp))
        })
      }
      return List
    },
    // 清除计时器
    clearTask () {
      if (this.getHintListTiming) {
        clearInterval(this.getHintListTiming)
        this.getHintListTiming = null
      }
    }
  },
  beforeDestroy () {
    console.warn('websocket-EpgIntervalHint')
    this.clearTask()
  }
}
</script>

<style scoped lang="less">
.EpgIntervalHint{
  .EpgIntervalHintWrap{
    position: relative;
    .exclamationPoinT{
      width: 50px;
      i{
        color: #FFB523;
        font-size: 20px;
      }
    }
    .IntervalHintWrap {
        position: absolute;
        top: 25px;
        right: -60px;
        padding-top: 12px;
        z-index: 11;
        .IntervalHint {
          position: relative;
          width: 366px;
          background: #333333;
          box-shadow: 0px 0px 15px 0px rgba(16, 4, 0, 0.72);
          border-radius: 8px;
          padding: 13px 16px 26px;
          text-align: left;
          .HintTitle{
            font-size: 14px;
            color: #FFB523;
            font-weight: 700;
            margin-bottom: 12px;
          }
          .HintContenTop{
            font-size: 14px;
            color: #FFB523;
            margin-bottom: 3px;
          }
          .UpdateTime{
            color: #999999;
            font-weight: 400;
            font-size: 12px;
            margin-bottom: 8px;
          }
          .HintContenList{
            height: 100px;
            overflow: auto;
            .HintContenItem{
              color: #DBDBDB;
              font-size: 14px;
            }
          }
        }
        .IntervalHint::after {
          content: "";
          border: solid 14px;
          border-color: transparent transparent #333333 transparent;
          position: absolute;
          top: -25px;
          right: 70px;
        }
    }
  }
  // .EpgIntervalHintWrap:hover .IntervalHintWrap{
  //   display: block;
  // }
}

</style>
